import { Component, forwardRef, inject, model } from "@angular/core";
import { BigButtonComponent } from "../big-button/big-button.component";
import { MatSnackBarRef } from "@angular/material/snack-bar";

@Component({
  selector: "vl-snack-component",
  standalone: true,
  imports: [forwardRef(() => BigButtonComponent)],
  templateUrl: "./snack-component.component.html",
  styleUrl: "./snack-component.component.scss",
})
export class SnackComponentComponent {
  snackRef = inject(MatSnackBarRef<SnackComponentComponent>);

  messages = model<string[]>();
  buttonText = model<string>();
  buttonIcon = model<string>();
  buttonFunction = model<() => void>();

  onAction() {
    this.buttonFunction()?.();
    this.snackRef.dismiss();
  }
}
